<template>
  <BaseNoticeItem
    :button-text="action ? $t(action.buttonText ?? 'Go to') : ''"
    :button-url="action?.action ?? ''"
    :status="$t('Information missing')"
    :data-test="`compliance-alert-${kebabCase(comp.name)}`"
  >
    <template #head>
      <strong>{{ $t(comp.title) }}</strong>
    </template>
    <template #body>
      {{ $t(comp.description) }}
    </template>
  </BaseNoticeItem>
</template>

<script setup lang="ts">
import kebabCase from 'lodash/kebabCase'
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import { ComplianceActorTypes } from '@/gql/graphql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'

const AccountComplianceAlert = graphql(`
  fragment AccountComplianceAlert on Compliance {
    name
    actor
    title
    description
    action {
      action
      buttonText
    }
  }
`)

const props = defineProps<{
  compliance: FragmentType<typeof AccountComplianceAlert>
}>()

const comp = computed(() => useFragment(AccountComplianceAlert, props.compliance))

// No CTA when Worksome is the responsible actor — the user can't resolve it themselves.
const action = computed(() =>
  comp.value.actor === ComplianceActorTypes.Worksome ? null : comp.value.action,
)
</script>
